'use strict';
/**
 * Exception that rise when a protocol registers and its identifier already
 * exists in registered protocols of neighborhood-wrtc.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var ExProtocolExists =
/**
   * @param {string} protocolId The identifier of the protocol that already
   * exists
   */
function ExProtocolExists(protocolId) {
  _classCallCheck(this, ExProtocolExists);

  this.pid = protocolId;
  this.message = 'The idenfifier of the registering protocol already exists.';
};

;
module.exports = ExProtocolExists;